export enum PhoneMenuItems {
	CALL_HISTORY = 'call_history',
	CONTACTS = 'contacts',
	NUMBER = 'number',
}
